var $          = require(65)
  , createDesc = require(71);
module.exports = require(46) ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};